export const mockCompanyInfo = {
  name: "Quidity Direct",
  tagline: "Cashflow Engineering",
  phone: "(305) 419-2446",
  email: "info@quiditydirect.com",
  address: {
    street: "9100 S. Dadeland Blvd",
    suite: "Suite 1500",
    city: "Miami",
    state: "FL",
    zip: "33156"
  },
  additionalLocations: [
    { name: "Trinidad and Tobago Office", address: "Level 2, Invaders Bay Tower\nInvaders Bay off Audrey Jeffers Highway\nPort of Spain\nTrinidad and Tobago" },
    { name: "Melbourne Office", address: "Level 21, 567 Collins Street\nMelbourne, VIC 3000\nAustralia" },
    { name: "London Office", address: "30 St Mary Axe\nLondon EC3A 8BF\nUnited Kingdom" },
    { name: "Houston Office", address: "8990 Kirby Drive, Suite 220\nHouston, TX 77054" },
    { name: "San Diego Office", address: "1455 Frazee Road, Suite 500\nSan Diego, CA 92108" },
    { name: "New York Office", address: "245 Park Avenue, 39th Floor\nNew York, NY 10167" },
    { name: "Johannesburg Office", address: "35 Fricker Road\nIllovo (Sandton), Johannesburg 2196\nSouth Africa" }
  ]
};

export const mockStats = {
  capitalDeployed: "$2B+",
  businessesFunded: "1,000+",
  averageApproval: "24hrs",
  clientSatisfaction: "98%"
};

export const mockTestimonials = [
  {
    name: "Maria Gonzalez",
    company: "Miami Construction Co.",
    quote: "Quidity helped us secure the working capital we needed to take on larger projects. Their team understood our business and made the process simple.",
  },
  {
    name: "Robert Kim",
    company: "Tech Solutions Inc.",
    quote: "The loan process seemed daunting, but Quidity guided us through every step. We got approved faster than we expected.",
  },
  {
    name: "Jennifer Adams",
    company: "Adams Manufacturing",
    quote: "Our line of credit has been a game changer for managing seasonal fluctuations. Highly recommend their services.",
  }
];
